import service from "./../../../services/purchase/supplierGroup"
import supplierGroupList from "./supplierGroupList";
import supplierGroupSearch from "./supplierGroupSearch";
export default {
    namespaced : true,
    modules: {
        list: supplierGroupList,
        search: supplierGroupSearch
    },
    actions: {
        create(context, payload) {
            return new Promise((resolve, reject) => {
                service.create(payload).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            });
        },
        update(context, payload) {
            return new Promise((resolve, reject) => {
                service.update(payload).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            });
        },
        findByID(context, payload) {
            return new Promise((resolve, reject) => {
                service.findByID(payload).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        deleteByID(context, payload) {
            return new Promise((resolve, reject) => {
                service.deleteByID(payload).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        search(context, payload) {
            return new Promise((resolve, reject) => {
                service.search(payload).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        }
    }
}